import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-04/lesson-14/task-01";

const task: Slide = {
  titleHtml:
    "You have only one microphone to record a duet of singers facing each other.<br>What type of polar pattern do you choose?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
